<template>
  <el-dialog :title="'绑定管理 - ' + (toolName || '')" :visible="visible"
             width="640px" v-dialogDrag :modal-append-to-body="false" v-if="visible"
             @update:visible="$emit('update:visible', $event)">
    <div class="bind_bar">
      <el-select v-model="addForm.agent_id" placeholder="选择数字员工" size="small" filterable style="width: 240px">
        <el-option v-for="a in agentOptions" :key="a.agent_id" :label="a.display_name || a.name" :value="a.agent_id" />
      </el-select>
      <el-switch v-model="addForm.enabled" active-text="启用" />
      <el-button type="primary" size="small" :loading="saving" @click="saveBind">添加绑定</el-button>
    </div>
    <el-table :data="bindings" v-loading="loading" border size="small">
      <el-table-column label="数字员工" min-width="160" show-overflow-tooltip>
        <template slot-scope="scope">{{ agentName(scope.row.agent_id) }}</template>
      </el-table-column>
      <el-table-column label="启用" width="100" align="center">
        <template slot-scope="scope">
          <el-switch v-model="scope.row.enabled" @change="toggleEnabled(scope.row)" />
        </template>
      </el-table-column>
      <el-table-column label="绑定时间" width="160">
        <template slot-scope="scope">{{ fmtTime(scope.row.ctime) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="80" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" size="small" class="danger_text" @click="delBind(scope.row)">解绑</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>
import { agentBody } from '../utils'

// 工具绑定管理弹窗（按工具维度）：bindings 为非分页结构（无 total）；set 的 enabled 不传等同 false，必须显式带
export default {
  name: 'AiAgentToolBindings',
  props: {
    visible: { type: Boolean, default: false },
    urls: { type: Object, required: true },
    toolId: { type: String, default: '' },
    toolName: { type: String, default: '' }
  },
  data() {
    return {
      bindings: [],
      loading: false,
      agentOptions: [],
      addForm: { agent_id: '', enabled: true },
      saving: false
    }
  },
  methods: {
    loadAgents() {
      this.$tools.asyncPost(this, this.urls.agentsList, agentBody({ page: 1, limit: 0 })).then((res) => {
        if (res.data.code == 0) this.agentOptions = res.data.data.data || []
      }).catch(() => {})
    },
    loadBindings() {
      this.loading = true
      this.$tools.asyncPost(this, this.urls.bindList,
        agentBody({ tool_id: this.toolId })).then((res) => {
        if (res.data.code == 0) this.bindings = res.data.data.data || []
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    agentName(id) {
      const a = this.agentOptions.find(x => x.agent_id === id)
      return a ? (a.display_name || a.name) : id
    },
    saveBind() {
      if (!this.addForm.agent_id) {
        return this.$message({ type: 'warning', message: '请选择数字员工' })
      }
      this.saving = true
      this.$tools.asyncPost(this, this.urls.bindSet,
        agentBody({ agent_id: this.addForm.agent_id, tool_id: this.toolId,
          enabled: this.addForm.enabled })).then((res) => {
        if (res.data.code == 0) {
          this.$message({ type: 'success', message: '绑定成功' })
          this.addForm = { agent_id: '', enabled: true }
          this.loadBindings()
        }
        this.saving = false
      }).catch((err) => {
        this.saving = false
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
      })
    },
    // 开关即 upsert（同 agent+tool 幂等）；code!=0 拦截器已弹错并 reject，走 catch 回滚
    toggleEnabled(row) {
      this.$tools.asyncPost(this, this.urls.bindSet,
        agentBody({ agent_id: row.agent_id, tool_id: this.toolId, enabled: row.enabled })).catch((err) => {
        row.enabled = !row.enabled
        if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
      })
    },
    // 解绑一律用 del（语义比 set false 更明确）
    delBind(row) {
      this.$MessageBox.confirm('确认解除「' + this.agentName(row.agent_id) + '」与该工具的绑定？', '提示', { type: 'warning' }).then(() => {
        this.$tools.asyncPost(this, this.urls.bindDel,
          agentBody({ agent_id: row.agent_id, tool_id: this.toolId })).then((res) => {
          if (res.data.code == 0) {
            this.$message({ type: 'success', message: '已解绑' })
            this.loadBindings()
          }
        }).catch((err) => {
          if (err && err.isAxiosError) this.$message({ type: 'error', message: '请求失败，请稍后重试' })
        })
      }).catch(() => {})
    },
    fmtTime(s) {
      if (!s) return '-'
      return this.$tools.parserDateTime('datetime', s) || s.substring(0, 19).replace('T', ' ')
    }
  },
  watch: {
    // v-if 随关随销毁：每次打开均为新实例，必须 immediate 才能在创建时加载
    visible: {
      immediate: true,
      handler(v) {
        if (!v) return
        this.addForm = { agent_id: '', enabled: true }
        this.bindings = []
        this.loadAgents() // 每次打开刷新，防 agents Tab 增删后过期
        this.loadBindings()
      }
    }
  }
}
</script>

<style lang="less" scoped>
.bind_bar {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}
.danger_text { color: #f56c6c; }
</style>
